export const localDateToServerDate = (localDate: Date): Date => {
  const date = new Date(localDate);
  const UTCHours = date.getHours();
  return new Date(date.setUTCHours(UTCHours));
};

type SomeObjectType = {
  [key: string]: any;
};

// recursive function to convert a date to a server date in nested objects
export const convertDateToServerDate = (obj: any): any => {
  if (obj instanceof Date) {
    return localDateToServerDate(obj);
  } else if (obj instanceof Array) {
    return obj.map(convertDateToServerDate);
  } else if (obj instanceof Object) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = convertDateToServerDate(obj[key]);
      return acc;
    }, {} as SomeObjectType);
  }
  return obj;
};
